export const FEATURE_REQUEST_PRIORITIES = [
  "Low",
  "Medium",
  "High",
  "Critical",
];

export const DEFAULT_FEATURE_REQUEST_PRIORITY = "Medium";

const normalizeIdentity = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const isFeatureRequestAdmin = (user) =>
  normalizeIdentity(user && user.displayName) === "admin888";

export const isFeatureRequestOwner = (user, request) => {
  if (!user || !request) return false;

  const ownerUid = String(request.createdByUid || "").trim();
  if (ownerUid) {
    return ownerUid === String(user.uid || "").trim();
  }

  const ownerEmail = normalizeIdentity(request.createdByEmail);
  if (ownerEmail) {
    return ownerEmail === normalizeIdentity(user.email);
  }

  const ownerName = normalizeIdentity(request.createdBy);
  return Boolean(
    ownerName && ownerName === normalizeIdentity(user.displayName),
  );
};

export const canEditFeatureRequest = (user, request) =>
  isFeatureRequestAdmin(user) || isFeatureRequestOwner(user, request);

export const canManageFeatureRequestStatus = isFeatureRequestAdmin;

export const canManageFeatureRequestClassification = isFeatureRequestAdmin;

export const resolveFeatureRequestPriority = (user, requestedPriority) => {
  if (
    canManageFeatureRequestClassification(user) &&
    FEATURE_REQUEST_PRIORITIES.includes(requestedPriority)
  ) {
    return requestedPriority;
  }

  return DEFAULT_FEATURE_REQUEST_PRIORITY;
};
